import * as PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, createSearchParams, useNavigate } from 'react-router-dom';
import AppConfig from '../../config';
import { t } from '../../lang';
import RequestService from '../../services/RequestService';
import Button from '../Button';
import { AddressItemWithSkeleton } from '../Skeletons/ItemsWithSkeleton';

import './AddressesBlock.scss';

const { routes } = AppConfig;

const AddressesBlock = ({ currency, addressesCount = 3 }) => {
	const [addresses, setAddresses] = useState([]);
	const [loading, setLoading] = useState(false);

	const permissions = useSelector(state => state.app.permissions);

	const navigate = useNavigate();

	const sortedAddresses = [...addresses].sort((a, b) => b.AmountUsd - a.AmountUsd);
	const cuttedAddresses = sortedAddresses.slice(0, addressesCount);
	const permissionToCreateAddress = permissions.address.Create;

	const getAddresses = async () => {
		try {
			setLoading(true);
			const response = await RequestService.GetAddressesByCurrency(currency.Id);
			setLoading(false);
			if (response?.Status === 'Success') {
				setAddresses(response.Addresses);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		getAddresses();
	}, []);

	const openAddress = address => {
		navigate({
			pathname: routes.address,
			search: createSearchParams({ currencyId: currency.Id }).toString(),
			hash: address.AddressId.toString(),
		});
	};

	const openCreateAddress = () => {
		navigate({ pathname: routes.createAddress, search: createSearchParams({ currencyId: currency.Id }).toString() });
	};

	return (
		<div className='AddressesBlock FormBlock'>
			{(!!cuttedAddresses.length || loading) && (
				<div className='AddressesBlock__header'>
					<div className='AddressesBlock__title'>{t('Addresses')}</div>
					<Link
						to={{
							pathname: routes.addresses,
							search: createSearchParams({ currencyId: currency.Id }).toString(),
						}}
					>
						{t('View all')}
					</Link>
				</div>
			)}

			{cuttedAddresses.length <= 0 && !loading && <div className='AddressesBlock__empty'>{t('No addresses yet')}</div>}

			<AddressItemWithSkeleton loading={loading} items={cuttedAddresses} onClick={openAddress} />

			<div className='AddressesBlock__button__container'>
				<Button
					styleType='secondary'
					className='AddressesBlock__button'
					iconBefore='PLUS_CIRCLE_FILL'
					onClick={openCreateAddress}
					disabled={!permissionToCreateAddress}
				>
					{t('Add address')}
				</Button>
			</div>
		</div>
	);
};

AddressesBlock.propTypes = {
	currency: PropTypes.object.isRequired,
	addressesCount: PropTypes.number,
};

export default AddressesBlock;
